import React from 'react';

const Divider = () => {
  return (
    <hr style={{
      marginLeft: 20,
      marginRight: 20,
    }} />
  )
};

export default Divider;
